import { HttpData } from '~/utils/network/HttpData';
import { apiBearerIam } from '../api';
import { useQuery } from '@tanstack/react-query';

export const useUserImportTemplate = () => {
  return useQuery<Blob>({
    queryKey: ['user', 'import-template'],
    queryFn: async () => {
      const response = await apiBearerIam({}).get(
        '/iam/user/v1/import-template',
        {
          responseType: 'blob',
        }
      );
      return response.data;
    },
  });
};
